// 「마지막 요청만 화면에 쓴다」 — 모달·목록 조회 공용(2026-09-27 재리뷰).
// 모달을 닫고 다른 채널로 빨리 다시 열거나 페이지를 넘기면 앞 요청의 응답이 늦게 도착해 새 화면을 덮을 수 있다.
// begin() 을 요청 시작 때 부르고, 돌려받은 isLatest() 가 false 면 응답을 버린다(로딩 끄기도 마지막 요청만).
import { useCallback, useRef } from "react";

export default function useLatestRequest() {
  const seqRef = useRef(0);
  return useCallback(() => {
    const seq = ++seqRef.current;
    return () => seq === seqRef.current;
  }, []);
}
